<template>
  <v-form
    v-model="formValide"
    ref="refAutresRevenusCandidat"
    lazy-validation
  >
    <v-dialog v-model="dialogImmo.informations.model" width="500">
      <v-card>
        <v-card-title>{{ $storeUm6p.Label.Informations }}</v-card-title>
        <v-card-text>
          <p v-html="$storeUm6p.Label.AutresRevenus.PopupNBBienImmoECC"></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="ecPrimary"
            text
            @click="dialogImmo.informations.model = false"
          >
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col cols="12">
      <label class="asterisk">
        {{ $storeUm6p.Label.AutresRevenus.CandidatProprietaire }}
      </label>
    </v-col>
    <v-col cols="6" md="4">
      <v-autocomplete
        dense
        v-model="$storeBourse.DonneesFormulaireEC.infosComplementaires.proprietaireDeBiensImmobiliersSecondaire"
        :item-text="$storeUniversite.itemLang"
        item-value="id"
        :items="$storeCatalogue.OuiNon"
        label=""
        outlined
        :rules="$storeReglesBourse.obligatoire"
        :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
        @change="
          DisplayPopup(
            $storeBourse.DonneesFormulaireEC.infosComplementaires
              .proprietaireDeBiensImmobiliersSecondaire
          );
          addBienImmo(false)
        "
      ></v-autocomplete>
    </v-col>
    <div
      v-show="
        $storeBourse.DonneesFormulaireEC.infosComplementaires.proprietaireDeBiensImmobiliersSecondaire ==
        $storeCatalogue.DataId.Oui
      "
    >
      <v-btn
        dark
        v-show="!$storeBourse.DonneesFormulaireEC.readOnly"
        @click="addBienImmo(true)"
        color="ecSecondary"
      >
        {{ $storeUm6p.Label.Ajouter }}
      </v-btn>
    </div>
    <v-simple-table
      v-show="
        $storeBourse.DonneesFormulaireEC.infosComplementaires.proprietaireDeBiensImmobiliersSecondaire ==
        $storeCatalogue.DataId.Oui
      "
    >
      <thead>
        <tr>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.NombreBiens }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.NatureBien }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.SuperficieBien }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.AdresseBien }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.NumeroTitreFoncier }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.DateAcquisitionBien }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.ValeurAcquisitionBien }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.ValeurEstimativeBien }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.SourceEstimationBien }}
          </th>
        </tr>
      </thead>
      <tbody
        v-for="(bien, index) in $storeBourse.DonneesFormulaireEC.listeProprietesCandidat"
        :key="bien.idCrypte"
      >
        <tr cols="12" v-show="!bien.Supprimer">
          <td class="pt-6">
            <v-text-field
              v-model="bien.nombreBiens"
              :rules="
                estProprietairedeBiensImmo
                  ? $storeReglesBourse.EstNumeriqueObligatoire
                  : []
              "
              :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
              outlined
              dense
            />
          </td>
          <td class="pt-6">
            <v-autocomplete
              :label="$storeUm6p.Label.NatureBien"
              v-model="bien.natureBien"
              item-text="lang00"
              item-value="id"
              :items="$storeCatalogue.NatureBien"
              clearable
              outlined
              :rules="
                estProprietairedeBiensImmo ? $storeReglesBourse.obligatoire : []
              "
              :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
              :ref="'natbien' + index"
              :itemprop="$storeUm6p.Label.AutresRevenus.NatureBien"
              dense
            ></v-autocomplete>
          </td>
          <td class="pt-6">
            <v-text-field
              v-model="bien.superficie"
              :rules="
                estProprietairedeBiensImmo
                  ? $storeReglesBourse.EstNumeriqueObligatoire
                  : []
              "
              :ref="'superficie' + index"
              :itemprop="$storeUm6p.Label.AutresRevenus.SuperficieBien"
              outlined
              :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
              dense
            />
          </td>
          <td class="pt-6">
            <v-text-field
              v-model="bien.adresse"
              :rules="
                estProprietairedeBiensImmo ? $storeReglesBourse.obligatoire : []
              "
              :ref="'adr' + index"
              :itemprop="$storeUm6p.Label.AutresRevenus.AdresseBien"
              :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
              outlined
              dense
            />
          </td>
          <td class="pt-6">
            <v-text-field
              v-model="bien.numeroTitreFoncier"
              :rules="
                estProprietairedeBiensImmo
                  ? $storeReglesBourse.obligatoire
                  : []
              "
              :ref="'numTitreFoncier' + index"
              :itemprop="$storeUm6p.Label.AutresRevenus.NumeroTitreFoncier"
              :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
              outlined
              dense
            />
          </td>
          <td
            class="pt-6"
            style="padding-top: 0px !important"
          >
            <input
              class="dateAcquisitionClass"
              type="date"
              v-model="bien.DateAcquisition"
              required
            />
          </td>
          <td class="pt-6">
            <v-text-field
              v-model="bien.valeurAcquisition"
              :rules="estProprietairedeBiensImmo
                  ? [
                      $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                        bien.valeurAcquisition
                      ),
                    ]
                  : []
              "
              :ref="'valeurAcquisition' + index"
              :itemprop="$storeUm6p.Label.AutresRevenus.ValeurAcquisitionBien"
              :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
              outlined
              dense
            />
          </td>
          <td class="pt-6">
            <v-text-field
              v-model="bien.valeurEstimative"
              :rules="estProprietairedeBiensImmo
                  ? [
                      $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                        bien.valeurEstimative
                      ),
                    ]
                  : []
              "
              :ref="'valeurEstimative' + index"
              :itemprop="$storeUm6p.Label.AutresRevenus.ValeurEstimativeBien"
              :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
              outlined
              dense
            />
          </td>
          <td class="pt-6">
            <v-text-field
              v-model="bien.sourceEstimation"
              :rules="estProprietairedeBiensImmo
                  ? $storeReglesBourse.obligatoire
                  : []
              "
              :ref="'sourceEstimation' + index"
              :itemprop="$storeUm6p.Label.AutresRevenus.SourceEstimationBien"
              :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
              outlined
              dense
            />
          </td>
          <td class="text-center">
            <v-icon
              v-show="!$storeBourse.DonneesFormulaireEC.readOnly
              && index > 0"
              small
              class="mr-2"
              @click="deleteBienImmo(bien)"
            >
              {{ icons.mdiDelete }}
            </v-icon>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <v-alert
              border="left"
              colored-border
              color="ecSecondary"
              elevation="1"
            >
              {{
                $storeUm6p.Label.AutresRevenus.AutresRevenusAnnuelsDirham +
                $storeUm6p.Label.AutresRevenus.AutresRevenusTitle +
                $storeBourse.DonneesFormulaireEC.anneeScolaireAutresRevenus?.lang00
              }}
            </v-alert>
          </v-col>
        </v-row>
        <v-simple-table>
          <tbody>
            <tr>
              <td>
                <label class="asterisk">{{
                  $storeUm6p.Label.AutresRevenus.RevenusAgricolesAnnuels
                }}</label>
              </td>
              <td>
                <VuetifyMoney
                  hide-details
                  dense
                  v-model="$storeBourse.DonneesFormulaireEC.autresRevenusCandidat.revenuAgricole"
                  v-bind:label="label"
                  v-bind:readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  v-bind:clearable="clearable"
                  v-bind:options="optionsDH"
                  :rules="$storeReglesBourse.obligatoire"
                  ref="revenuagricole"
                  :itemprop="
                    $storeUm6p.Label.AutresRevenus.RevenusAgricolesAnnuels
                  "
                />
              </td>
              <td>
                <label class="asterisk">{{
                  $storeUm6p.Label.AutresRevenus.RevenusLocatifNef
                }}</label>
              </td>
              <td>
                <VuetifyMoney
                  hide-details
                  dense
                  v-model="$storeBourse.DonneesFormulaireEC.autresRevenusCandidat.revenuLocatifNet"
                  v-bind:label="label"
                  v-bind:readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  :rules="$storeReglesBourse.obligatoire"
                  ref="revenulocatif"
                  :itemprop="$storeUm6p.Label.AutresRevenus.RevenusLocatifNef"
                  v-bind:clearable="clearable"
                  v-bind:options="optionsDH"
                />
              </td>
            </tr>
            <tr>
              <td>
                <label class="asterisk">
                  {{ $storeUm6p.Label.AutresRevenus.Dividendes }}</label
                >
              </td>
              <td>
                <VuetifyMoney
                  hide-details
                  dense
                  v-model="$storeBourse.DonneesFormulaireEC.autresRevenusCandidat.dividendes"
                  v-bind:label="label"
                  v-bind:readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  :rules="$storeReglesBourse.obligatoire"
                  ref="dividendes"
                  :itemprop="$storeUm6p.Label.AutresRevenus.Dividendes"
                  v-bind:clearable="clearable"
                  v-bind:options="optionsDH"
                />
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                <label class="asterisk">
                  {{ $storeUm6p.Label.AutresRevenus.AutreRevenusNetAnnuels }}
                </label>
              </td>
              <td>
                <VuetifyMoney
                  hide-details
                  dense
                  v-model="$storeBourse.DonneesFormulaireEC.autresRevenusCandidat.autresRevenus"
                  v-bind:label="label"
                  v-bind:readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  :rules="$storeReglesBourse.obligatoire"
                  ref="autresrevenus"
                  :itemprop="
                    $storeUm6p.Label.AutresRevenus.AutreRevenusNetAnnuels
                  "
                  v-bind:clearable="clearable"
                  v-bind:options="optionsDH"
                />
              </td>
              <td>
                <label
                  :class="
                    $storeBourse.DonneesFormulaireEC.autresRevenusCandidat.autresRevenus > 0
                      ? 'asterisk'
                      : ''
                  "
                >
                  {{ $storeUm6p.Label.AutresRevenus.PrecisezLaNature }}
                </label>
              </td>
              <td>
                <v-text-field
                  dense
                  outlined
                  v-model="$storeBourse.DonneesFormulaireEC.autresRevenusCandidat.natureRevenus"
                  :rules="
                    $storeBourse.DonneesFormulaireEC.autresRevenusCandidat.autresRevenus > 0
                      ? $storeReglesBourse.obligatoire
                      : []
                  "
                  ref="naturerevenus"
                  :itemprop="$storeUm6p.Label.AutresRevenus.NatureAutresRevenus"
                  :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                />
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-row>
          <v-col cols="12">
            <v-alert
              border="left"
              colored-border
              color="ecSecondary"
              elevation="1"
            >
              {{
                $storeUm6p.Label.AutresRevenus.RevenuExceptionnels +
                $storeUm6p.Label.AutresRevenus.AutresRevenusTitle +
                $storeBourse.DonneesFormulaireEC.anneeScolaireAutresRevenus?.lang00
              }}
            </v-alert>
          </v-col>
        </v-row>
        <v-simple-table>
          <tbody>
            <tr>
              <td>
                <label class="asterisk">
                  {{ $storeUm6p.Label.AutresRevenus.ProduitVenteImmo }}
                </label>
              </td>
              <td>
                <VuetifyMoney
                  hide-details
                  dense
                  v-model="$storeBourse.DonneesFormulaireEC.autresRevenusCandidat.produitVenteBien"
                  v-bind:label="label"
                  v-bind:readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  :rules="$storeReglesBourse.obligatoire"
                  ref="produitventebien"
                  :itemprop="$storeUm6p.Label.AutresRevenus.ProduitVenteImmo"
                  v-bind:clearable="clearable"
                  v-bind:options="optionsDH"
                />
              </td>
              <td>
                <label class="asterisk">{{
                  $storeUm6p.Label.AutresRevenus.Heritages
                }}</label>
              </td>
              <td>
                <VuetifyMoney
                  hide-details
                  dense
                  v-model="$storeBourse.DonneesFormulaireEC.autresRevenusCandidat.heritage"
                  v-bind:label="label"
                  v-bind:readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  :rules="$storeReglesBourse.obligatoire"
                  ref="heritage"
                  :itemprop="$storeUm6p.Label.AutresRevenus.Heritages"
                  v-bind:clearable="clearable"
                  v-bind:options="optionsDH"
                />
              </td>
            </tr>
            <tr>
              <td>
                <label class="asterisk">
                  {{
                    $storeUm6p.Label.AutresRevenus.AutresRevenusExceptionnels
                  }}
                </label>
              </td>
              <td>
                <VuetifyMoney
                  hide-details
                  dense
                  v-model="
                    $storeBourse.DonneesFormulaireEC.autresRevenusCandidat.autresRevenusExceptionnels
                  "
                  v-bind:label="label"
                  v-bind:readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                  v-bind:disabled="disabled"
                  :rules="$storeReglesBourse.obligatoire"
                  ref="autresrevenusexc"
                  :itemprop="
                    $storeUm6p.Label.AutresRevenus.AutresRevenusExceptionnels
                  "
                  v-bind:outlined="outlined"
                  v-bind:clearable="clearable"
                  v-bind:options="optionsDH"
                />
              </td>
              <td>
                <label
                  :class="
                    $storeBourse.DonneesFormulaireEC.autresRevenusCandidat.autresRevenusExceptionnels > 0
                      ? 'asterisk'
                      : ''
                  "
                >
                  {{ $storeUm6p.Label.AutresRevenus.PrecisezLaNature }}
                </label>
              </td>
              <td>
                <v-text-field
                  dense
                  outlined
                  v-model="
                    $storeBourse.DonneesFormulaireEC.autresRevenusCandidat.natureRevenusExceptionnels
                  "
                  :rules="
                    $storeBourse.DonneesFormulaireEC.autresRevenusCandidat.autresRevenusExceptionnels > 0
                      ? $storeReglesBourse.obligatoire
                      : []
                  "
                  ref="natureautrerevenuexc"
                  :itemprop="$storeUm6p.Label.AutresRevenus.PrecisezLaNatureExc"
                  :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                />
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import VuetifyMoney from "../VuetifyMoney";
import { mdiPlusThick, mdiDelete } from "@mdi/js";
export default {
  name: "AutresRevenusCandidat",
  components: {
    VuetifyMoney,
  },
  data() {
    return {
      formValide:false,
      $storeUm6p: this.$storeUm6p,
      $storeBourse: this.$storeBourse,
      $storeReglesBourse: this.$storeReglesBourse,
      $storeCatalogue: this.$storeCatalogue,
      dialogImmo: {
        informations: {
          model: false,
          texte: null,
        },
      },

      // Icon importés depuis mdi/js pour les icones d'édition/suppression
      icons: {
        mdiPlusThick,
        mdiDelete,
      },
      // Param des rubriques revenus
      label: "",
      disabled: false,
      outlined: true,
      clearable: false,
      optionsDH: {
        locale: "fr-FR",
        prefix: "DH",
        suffix: "",
        length: 9,
        precision: 2,
      },
      optionsEUR: {
        locale: "fr-FR",
        prefix: "EUR",
        suffix: "",
        length: 9,
        precision: 2,
      },
    };
  },
  computed: {
    estProprietairedeBiensImmo() {
      return (
        this.$storeBourse.DonneesFormulaireEC.infosComplementaires
          .proprietaireDeBiensImmobiliersSecondaire ==
        this.$storeCatalogue.DataId.Oui
      );
    },
    newBien(){
      return {
        Supprimer: false,
        CandidatureBourse: this.$storeDemandeBourse.DonneesFormulaire.EncryptId,
        CandidatureBourseFirsi: this.$storeUm6p.Formulaire.Id,
        IdCrypte: null,
        SituationFamiliale: null,
        Adresse: null,
        Duree: null,
        NombreBiens: null,
        NumeroTitreFoncier: null,
        DateAcquisition: null,
        ValeurAcquisition: null,
        ValeurEstimative: null,
        SourceEstimation: null,
        MontantEcheance: null,
        MontantGlobal: null,
        Superficie: null,
        FinancementPropriete: this.$storeCatalogue.DataId.TypeRevenuPropriete,
        NatureBien: null,
        PersonneConcernee:
          this.$storeCatalogue.DataId.PersonneConcerneeCandidat,
        TypeFinancement: null,
      }
    }
  },
  mounted() {
    this.$refs.refAutresRevenusCandidat.resetValidation();
  },
  created() {
  },
  methods: {
    DisplayPopup(value) {
      if (value == this.$storeCatalogue.DataId.Oui) {
        this.dialogImmo.informations.model = true;
      } else if (
        value == this.$storeCatalogue.DataId.Non
      ) {
        this.$storeBourse.DonneesFormulaireEC.listeProprietesCandidat.splice(0);
      }
    },
    ValiderForm() {
      this.$refs.refAutresRevenusCandidat.validate();
      let listeErreur = [];
      Object.keys(this.$refs).forEach((key) => {
        if (key != "refAutresRevenusCandidat") {
          if (
            (!this.$refs[key].valid && this.$refs[key].valid != undefined) ||
            (this.$refs[key].valid == undefined &&
              this.$refs[key].$children != undefined &&
              this.$refs[key].$children[0] != undefined &&
              !this.$refs[key].$children[0].valid) ||
            (this.$refs[key][0] != undefined && !this.$refs[key][0].valid)
          ) {
            let label = this.$refs[key].label;
            if (!label) {
              let inp = this.$refs[key];
              if (!inp.$attrs) {
                inp = inp[0];
              }
              label = inp.$attrs["itemprop"];
            }
            listeErreur.push(label);
          }
        }
      });
      return listeErreur;
    },
    addBienImmo(flag) {
      if(this.$storeBourse.DonneesFormulaireEC.infosComplementaires.proprietaireDeBiensImmobiliersSecondaire == this.$storeCatalogue.DataId.Oui){
        if(flag){
          this.$storeBourse.DonneesFormulaireEC.listeProprietesCandidat.push(Object.assign({},this.newBien));
        }
        else if(!flag && this.$storeBourse.DonneesFormulaireEC.listeProprietesCandidat.length === 0){
          this.$storeBourse.DonneesFormulaireEC.listeProprietesCandidat.push(Object.assign({},this.newBien));
        }
      }
      else{
        this.$storeBourse.DonneesFormulaireEC.listeProprietesCandidat.splice(0);
      }
    },
    deleteBienImmo(bien) {
      if (confirm("Etes-vous sûr de vouloir supprimer cette ligne?")) {
        this.bienIndex = this.$storeBourse.DonneesFormulaireEC.listeProprietesCandidat.indexOf(bien);

        var item = Object.assign({}, bien);
        item.Supprimer = true;
        Object.assign(
          this.$storeBourse.DonneesFormulaireEC.listeProprietesCandidat[this.bienIndex],
          item
        );

        this.bienIndex = -1;
      }
    },
  },
};
</script>
<style scoped src="@/assets/css/Um6pAutresRevenus.css"></style>
<style scoped src="@/assets/css/DemandeBourse.css"></style>
